import { createUID } from '@pega/cosmos-react-core';
import type { DraggableItem, DraggableProps, ItemRendererProps } from '@pega/cosmos-react-dnd';

import { StyledDemoDragDropListItem, StyledEmptyItem } from './DragDropList.styles';

interface ItemData {
  content: string;
  color: string;
}

export const createMockDataArray = (
  length: number,
  type: DraggableProps['type'],
  listId: string
): DraggableItem<ItemData>[] => {
  return Array.from({ length }, (_, i) => {
    const id = `${i}`;
    return {
      type,
      id: createUID(),
      data: {
        content: `Item ${listId}:${id}`,
        color: `hsl(${(i * 360) / length}deg, 100%, 66%)`
      }
    };
  });
};

export const EmptyItem = () => {
  return <StyledEmptyItem>No Items</StyledEmptyItem>;
};

export const DemoListItem = ({
  id,
  type,
  dragRef,
  data,
  isDragging,
  ...restProps
}: ItemRendererProps<ItemData>) => {
  return (
    <StyledDemoDragDropListItem
      ref={dragRef}
      style={{
        opacity: isDragging ? '0.5' : undefined,
        backgroundColor: data?.color ?? 'white'
      }}
      {...restProps}
    >
      {data?.content}
    </StyledDemoDragDropListItem>
  );
};

export const sort = (a: DraggableItem<ItemData>, b: DraggableItem<ItemData>): number => {
  return a.data!.content.localeCompare(b.data!.content);
};

export const itemType = Symbol('');
export const mockDataArrayA = createMockDataArray(10, itemType, 'A');
export const mockDataArrayB = createMockDataArray(4, itemType, 'B');
